import { StatusScreen, initMercadoPago } from '@mercadopago/sdk-react';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY || '');

const apiUrl = process.env.REACT_APP_API_URL || '';

interface Props {
    paymentId: string; // ID do pagamento a ser mostrado
    paymentMpId: string; // ID do pagamento no Mercado Pago
    onChange?: (status: string) => void; // Callback opcional para mudanças de status
};

export default function StatusBrick({ paymentId, paymentMpId, onChange }: Props) {
    const [datetime, setDatetime] = useState<Date>(new Date());
    const datetimeRef = useRef<Date>(datetime);

    useEffect(() => {
        datetimeRef.current = datetime;
    }, [datetime]);

    useEffect(() => {
        const interval = setInterval(() => {
            const current = datetimeRef.current;

            fetch(`${apiUrl}/payments/is-updated/${paymentId}?datetime=${current.toISOString()}`)
                .then(async (res) => {
                    const data = await res.json();
                    if (res.ok) {
                        return data;
                    } else {
                        return Promise.reject(data.message || 'Ocorreu um erro desconhecido.');
                    }
                })
                .then(data => {
                    if (data.isMoreRecent) {
                        setDatetime(new Date());
                    }
                    if(data.approved) {
                        clearInterval(interval);
                        if (onChange) {
                            onChange('approved');
                        }
                    }
                })
                .catch(error => {
                    console.error('Erro na requisição fetch:', error);
                });
        }, 5000); // Atualiza a cada 5 segundos

        return () => clearInterval(interval);
    }, [paymentMpId]);

    const initialization = {
        paymentId: paymentMpId, // id do pagamento a ser mostrado
    };

    const customization = {
        visual: {
            hideFormTitle: true,
            style: {
                theme: "bootstrap" as const,
            },
        },
    };

    const callbacks = {
        onReady: () => {
            // Opcional: ocultar loading
        },
        onError: (error: any) => console.error('Erro no StatusBrick:', error),
    };

    return (
        <StatusScreen
            initialization={initialization}
            customization={customization}
            onReady={callbacks.onReady}
            onError={callbacks.onError}
        />

    );
}
